import Vue from 'vue'
import {mapActions} from 'vuex'

import AppLogos from 'js/components/layout-footer/_app-logos.js'
import ContactMixin from 'js/mixins/contact-modal-mixin'
import AddressInfo from 'js/components/address-info/index.js'
import PhoneNumber from 'js/components/phone-number/index.js'
import ComplaintsBook from 'js/components/complaints-book/index.js'
import FollowUs from 'js/components/follow-us/index.js'
import LogosEspana from 'assets/images/logos_españa.svg'
import LogosTransporte from 'assets/images/logo_transpPublico.png'
import FooterUE from 'assets/images/ES-Financiado-por-la-Union-Europea_POS-1024x301.svg'
import FooterMT from 'assets/images/Logotipo_del_Ministerio_de_Transportes_y_Movilidad_Sostenible 1.svg'
import FooterGC from 'assets/images/Group 2746.svg'
import FooterRT from 'assets/images/Group 1406.svg'

// Nuevas version, mantenga para cuando cambia el alcance
// import FooterUE from 'assets/images/footer UE_uniform_new.svg'
// import FooterMT from 'assets/images/footer MT_uniform_new.svg'

import template from './index.pug'

Vue.component('layout-footer', {
  name: 'layout-footer-cust-gc',
  template: template(),

  components: {
    AppLogos,
    AddressInfo,
    PhoneNumber,
    ComplaintsBook,
    FollowUs
  },

  mixins: [ContactMixin],

  data() {
    return {
      LogosEspana,
      logoTransporte: LogosTransporte,
      footerUE: FooterUE,
      footerMT: FooterMT,
      footerRT: FooterRT,
      footerGC: FooterGC
    }
  },

  methods: {
    ...mapActions(['openLanguageModal']),

    goToTransportRequest() {
      this.$router.push({name: 'transport-request'})
    },

    goToGeneralConditionsOfTransport() {
      const url = 'https://autgc.org/movilidad/'
      window.open(url)
    },

    goInstitutionalInformation() {
      const url = 'https://autgc.org/el-consorcio/'
      window.open(url)
    },

    goTo(destination) {
      const url = this.destinations[destination]
      window.open(url)
    },

    goToPrivacyPolicy() {
      const url = 'https://autgc.org/politica-de-privacidad/'
      window.open(url)
    },
  }
})
